import { Dispatch } from "react";
import {
    FieldId,
    Formality,
    Glossary,
    LabeledLocale,
    Locale,
    TranslatableField,
    TranslationValue,
} from "../lib";
import { UsageResponse } from "../services/types";

export interface TranslationRequest {
    fieldId: FieldId;
    label: string;
    from: Locale;
    to: Locale[];
    formality: Formality;
    value: TranslationValue;
}

export interface State {
    translationRequests: TranslationRequest[];
    formality: Formality;
    glossary?: Glossary;
    contentfulLocales: LabeledLocale[];
    deeplSourceLocales: Locale[];
    deeplTargetLocales: Locale[];
    isTranslating: boolean;
    lastChangedTranslationFieldId: string | null;
    usage: UsageResponse;
}

export const defaultState: State = {
    translationRequests: [],
    formality: "default",
    glossary: undefined,
    contentfulLocales: [],
    deeplSourceLocales: [],
    deeplTargetLocales: [],
    isTranslating: false,
    lastChangedTranslationFieldId: null,
    usage: {
        character_count: 0,
        character_limit: 0,
    },
};
interface HandleFieldChangePayload {
    field: TranslatableField;
    locale: Locale;
    value: TranslationValue;
    formality: Formality;
    targetLocales: Locale[];
    translationRequests: TranslationRequest[];
}
export type ContextDefaultValue = [State, Dispatch<Action>];

export type Action =
    | {
          type: ACTION_TYPE.SET_TRANSLATION_TO;
          payload: {
              fieldId: FieldId;
              toLocale: Locale;
          };
      }
    | {
          type: ACTION_TYPE.SET_ALL_TRANSLATION_TO;
          payload: {
              fieldId: FieldId;
              toLocales: Locale[];
              toggle: "add" | "remove";
          };
      }
    | { type: ACTION_TYPE.SET_TRANSLATION_FROM; payload: { fieldId: FieldId; fromLocale: Locale } }
    | { type: ACTION_TYPE.SET_FORMALITY; payload: { fieldId: FieldId; formality: Formality } }
    | {
          type: ACTION_TYPE.SET_TRANSLATION_REQUESTS;
          payload: TranslationRequest[];
      }
    | { type: ACTION_TYPE.SET_IS_TRANSLATING; payload: boolean }
    | { type: ACTION_TYPE.HANDLE_FIELD_CHANGE; payload: HandleFieldChangePayload };

export enum ACTION_TYPE {
    SET_TRANSLATION_TO = "SET_TRANSLATION_TO",
    SET_ALL_TRANSLATION_TO = "SET_ALL_TRANSLATION_TO",
    SET_TRANSLATION_FROM = "SET_TRANSLATION_FROM",
    SET_FORMALITY = "SET_FORMALITY",
    SET_TRANSLATION_REQUESTS = "SET_TRANSLATION_REQUESTS",
    SET_IS_TRANSLATING = "SET_IS_TRANSLATING",
    HANDLE_FIELD_CHANGE = "HANDLE_FIELD_CHANGE",
}
